import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {}

const dataChangesSlice = createSlice({
  name: 'dataChange',
  initialState,
  reducers: {
    updateDataChange: (state: any, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})

export const dataChangesActionsCreator = dataChangesSlice.actions

export default dataChangesSlice
